module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/account-points-icon.7b2ee446.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/account-points-icon.png
// module id = 2950
// module chunks = 11